import { createFileRoute } from "@tanstack/react-router";
import { ContractChannelAnalysisPage } from "@/features/contracts/contract-channel-analysis-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia/proporcje-kanalow")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.proporcje-kanalow",
			location.pathname,
		);
	},
	component: ContractChannelAnalysisPage,
});
